import { bus } from '../engine/EventBus';

export class Toast {
  private stack: HTMLDivElement;

  constructor(root: HTMLElement) {
    this.stack = document.createElement('div');
    this.stack.className = 'toast-stack';
    root.appendChild(this.stack);
    bus.on('toast', ({ message }) => this.push(message));
  }

  push(message: string): void {
    const el = document.createElement('div');
    el.className = 'toast';
    el.textContent = message;
    this.stack.appendChild(el);
    setTimeout(() => el.remove(), 3200);
  }
}
